import React from "react";

/**
 * Logo component — ALWAYS sets height only, width auto. Never distorts.
 *
 * variant: "color" (for light backgrounds) | "white" (for dark backgrounds)
 * height: number in px (default 32)
 */
export default function Logo({ variant = "color", height = 32, className = "", alt = "The English Academy" }) {
  const src = variant === "white" ? "/brand/logo-white.png" : "/brand/logo-color.png";
  return (
    <img
      src={src}
      alt={alt}
      style={{ height: `${height}px`, width: "auto" }}
      className={className}
      data-testid={`logo-${variant}`}
    />
  );
}
